/**
 * <StudentOfferSlot> — ce que les réalisations de l'élève posent au-dessus de leur liste
 * (`topSlot`) : la carte d'offre, encadrée, l'offre Essentielle ou la pause.
 */
import React from "react"

import { HighlightFrame } from "../../../../../../design-system"
import { TrialOfferCard } from "../../../../../../design-system/student"
import { type StudentOffer } from "../../../../adapters/student/shared/studentOfferAdapter"

export type StudentOfferSlotProps = {
    offer: StudentOffer
    onStartTrial: () => void
    onAskQuestion: () => void
}

export function StudentOfferSlot(props: StudentOfferSlotProps) {
    const { offer, onStartTrial, onAskQuestion } = props
    return (
        <HighlightFrame>
            {offer.kind === "paused" ? (
                <TrialOfferCard onAskQuestion={onAskQuestion} pausePeriod={offer.pausePeriod} />
            ) : (
                <TrialOfferCard onStartTrial={onStartTrial} />
            )}
        </HighlightFrame>
    )
}
